/*
 * @Author: ymk
 * @Date: 2020-07-23 09:52:48
 * @LastEditors: ymk
 * @LastEditTime: 2020-07-28 15:40:12
 * @FilePath: \car-demo\src\router\index.js
 */

import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import Home from '../views/Home.vue'
import Empty from '../views/Empty.vue'
import CustomForm from '../views/CustomForm.vue'

import homeRoutes from './home' // 首页
import stRoutes from './st' //驾校展厅
import orderRoutes from './order' //订单
import rankingRoutes from './ranking' // 红人榜
import pintuanRoutes from './pintuan' // 拼团学车
import userRoutes from './user' // 用户中心
import tabbar from '@/components/Tabbar' // 用户中心

const routes = [

    {

        path: '', name: 'tabbar', component: tabbar, children: [
            {path: '/', name: 'Home', component: Home,},

            // 优惠券
            {path: '/CouponSection', name: 'CouponSection', component: () => import('../views/CouponSection.vue'),},
            // 在线投诉
            {path: '/complain', name: 'Complain', component: () => import('../views/Complain.vue')},
            {path: '/pintuan', name: 'Pintuan', component: () => import('../views/Pintuan/list.vue')},
            {
                path: '/ranking',
                name: 'Ranking',
                component: () => import('../views/Ranking/index.vue'),
                redirect: '/ranking/instructor',
                children: [
                    {// 教练红人榜
                        path: 'instructor',
                        name: 'Instructor',
                        component: () => import('../views/Ranking/Instructor.vue')
                    },
                    {// 金牌打赏人
                        path: 'customer',
                        name: 'Customer',
                        component: () => import('../views/Ranking/Customer.vue')
                    }
                ]
            },
            {
                path: '/StList',
                name: 'StList',
                component: () => import('../views/StExhibitionHall/StList.vue'),
            },
            {
                path: '/user',
                name: 'User',
                component: () => import('../views/User/index.vue')
            },
        ]
    },
    // 帮我找驾校
    {path: '/FindDriving', name: 'FindDriving', component: () => import('../views/FindDriving.vue')},
    {path: '/empty', name: 'Empty', component: Empty,},
    {path: '/CustomForm', name: 'CustomForm', component: CustomForm,},
    // 转盘抽奖
    {path: '/luckydraw', name: 'LuckyDraw', component: () => import('../views/LuckyDraw.vue'),},


    // 活动规则
    {path: '/rules', name: 'Rules', component: () => import('../views/Rules.vue')},
    {path: '/share-poster', name: 'SharePoster', component: () => import('../views/SharePoster.vue')},
    ...homeRoutes,
    ...stRoutes,
    ...orderRoutes,
    ...rankingRoutes,
    ...pintuanRoutes,
    ...userRoutes,
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes,
})

router.afterEach((to, from, next) => {
    window.scrollTo(0, 0)
})

export default router
